import ResourceCard from './ResourceCard';
import strings from '../../../strings/strings.json';
import AddIcon from 'assets/icons/controls/AddIcon';
import Button from 'components/buttons/Button';
import { ResourcesContainer } from '../shared-styles/courseBuilderFormComponents';
import { Card, Headline3 } from 'components/Elements';
import { ResourcesInput } from './activityForms/shared/SharedActivityFormComponents';

type ResourcesListInput = {
    resources: ResourcesInput[];
    toggleModalOpen: () => void;
    deleteResource: (index: number) => void;
    disabled?: boolean;
    addLinkButtonRef?: React.RefObject<HTMLButtonElement>;
};

export default function ResourcesList(props: ResourcesListInput): JSX.Element {
    const { resources, deleteResource, toggleModalOpen, disabled } = props;

    return (
        <>
            <Headline3>{strings.resourcesList.title}</Headline3>
            <ResourcesContainer>
                {resources.map((resource, index) => (
                    <Card key={index}>
                        <ResourceCard
                            index={index}
                            resource={resource}
                            deleteResource={() => deleteResource(index)}
                            disabled={disabled ?? false}
                        />
                    </Card>
                ))}
                <Button
                    ref={props.addLinkButtonRef}
                    title={strings.resourcesForm.addResourcesButton}
                    aria={strings.resourcesForm.addResourcesButtonAria}
                    icon={<AddIcon />}
                    onClick={() => toggleModalOpen()}
                    disabled={disabled ?? false}
                    fullwidth
                />
            </ResourcesContainer>
        </>
    );
}
